import React from 'react';

function FormButtons({ onClear, onSubmit, submitText = "提出する", clearText = "クリア", disabled = false }) {
  return (
    <div className="flex justify-end gap-4 pt-4">
      <button
        type="button"
        onClick={onClear}
        disabled={disabled}
        className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        {clearText}
      </button>
      <button
        type="submit"
        disabled={disabled}
        className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium disabled:bg-blue-400 disabled:cursor-not-allowed"
      >
        {submitText}
      </button>
    </div>
  );
}

export default FormButtons;
